import { LinkButton as BaseLinkButton } from 'radiance-ui';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';
import styled from '@emotion/styled';

export const LinkButton = styled(BaseLinkButton)`
  width: 100%;
  ${MEDIA_QUERIES.mdUp} {
    max-width: 18rem;
  }
  margin: ${SPACER.small} auto 0;
`;
